import { TippyProps } from "@tippy.js/react";
import React from "react";
import { Placement } from "tippy.js";
import { Tooltip } from "./Tooltip";
import { deprecationWarning } from "./utils/warning";

type TooltipHelpProps = {
  content: TippyProps["content"];
  placement?: Placement;
};

/**
 * @deprecated Use `Tooltip.Help` instead
 */
export const TooltipHelp: React.FC<TooltipHelpProps> = (props) => {
  deprecationWarning("TooltipHelp", "Tooltip.Help");
  return <Tooltip.Help {...props} />;
};
